import { render, staticRenderFns } from "./VideosList.vue?vue&type=template&id=44ec4ef4&scoped=true&"
import script from "./VideosList.vue?vue&type=script&lang=js&"
export * from "./VideosList.vue?vue&type=script&lang=js&"
import style0 from "./VideosList.vue?vue&type=style&index=0&id=44ec4ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ec4ef4",
  null
  
)

export default component.exports